import {
    FETCH_CATEGORIES_BEGIN,
    FETCH_CATEGORIES_SUCCESS,
    FETCH_CATEGORIES_ERROR,
    POST_CATEGORIES_BEGIN,
    POST_CATEGORIES_SUCCESS,
    POST_CATEGORIES_ERROR,
    POST_CATEGORIES_RESET,
    FETCH_CATEGORIES_TRI_BEGIN,
    FETCH_CATEGORIES_TRI_SUCCESS,
    FETCH_CATEGORIES_TRI_ERROR,

    FETCH_LOTS_BEGIN,
    FETCH_LOTS_SUCCESS,
    FETCH_LOTS_ERROR,
    POST_LOTS_BEGIN,
    POST_LOTS_SUCCESS,
    POST_LOTS_ERROR,
    POST_LOTS_RESET,

    FETCH_ITEMS_BEGIN,
    FETCH_ITEMS_SUCCESS,
    FETCH_ITEMS_ERROR,
    POST_ITEMS_BEGIN,
    POST_ITEMS_SUCCESS,
    POST_ITEMS_ERROR,
    POST_ITEMS_RESET,

    FETCH_LOTUSAGES_BEGIN,
    FETCH_LOTUSAGES_SUCCESS,
    FETCH_LOTUSAGES_ERROR,
    POST_LOTUSAGES_BEGIN,
    POST_LOTUSAGES_SUCCESS,
    POST_LOTUSAGES_ERROR,
    POST_LOTUSAGES_RESET,

    FETCH_ITEMCHECKER_BEGIN,
    FETCH_ITEMCHECKER_ERROR,
    FETCH_ITEMCHECKER_SUCCESS,
} from '../actions/inventaireActions'

const initialState = {
    categories: [],
    categoriesTri: [],
    items: [],
    lots: [],
    lotUsages: [],
    itemChecker: {},
    fetchCategories: {
        loading: false,
        error: false,
        errorDetails: {}
    },
    fetchCategoriesTri: {
        loading: false,
        error: false,
        errorDetails: {}
    },
    postCategories: {
        saved: false,
        saving: false,
        error: false
    },
    fetchLots: {
        loading: false,
        error: false,
        errorDetails: {}
    },
    postLots: {
        saved: false,
        saving: false,
        error: false
    },
    fetchItems: {
        loading: false,
        error: false,
        errorDetails: {}
    },
    postItems: {
        saved: false,
        saving: false,
        error: false
    },
    fetchLotUsages: {
        loading: false,
        error: false,
        errorDetails: {}
    },
    postLotUsages: {
        saved: false,
        saving: false,
        error: false
    },
    fetchItemChecker: {
        loading: false,
        error: false
    },
}

export default function inventaireReducer(state = initialState, action) {
    let nextState
    switch (action.type) {
        // SET CATEGORIE SOUSCATEGORIE
        case 'SET_CATEGORIE':
            const categorieIndex = state.categories.findIndex((categorie) => categorie.id === action.value.id)
            if (categorieIndex !== -1) {
                let tempcategories = [
                    ...state.categories.slice(0, categorieIndex),
                    action.value,
                    ...state.categories.slice(categorieIndex + 1)
                ]
                nextState = {
                    ...state,
                    categories: tempcategories
                }
            }
            else {
                nextState = {
                    ...state,
                    categories: [...state.categories, action.value]
                }
            }
            return nextState
        case 'REMOVE_CATEGORIE':
            return {
                ...state,
                categories: state.categories.filter(cat => cat.id !== action.value)
            }

        case 'SET_ITEM':
            let categorie = state.categories[action.categorieIndex]
            let itemIndex = categorie.items.findIndex((item) => item.id === action.value.id)
            if (itemIndex !== -1) {
                let tempItem = [
                    ...state.categories[action.categorieIndex].items.slice(0, itemIndex),
                    action.value,
                    ...state.categories[action.categorieIndex].items.slice(itemIndex + 1)
                ]
                categorie.items = tempItem
                nextState = {
                    ...state,
                    categories: [
                        ...state.categories.slice(0, action.categorieIndex),
                        categorie,
                        ...state.categories.slice(action.categorieIndex + 1)
                    ]
                }
                return nextState
            }
            else {
                categorie.items.push(action.value)
                nextState = {
                    ...state,
                    categories: [
                        ...state.categories.slice(0, action.categorieIndex),
                        categorie,
                        ...state.categories.slice(action.categorieIndex + 1)
                    ]
                }
            }
            return nextState
        case 'REMOVE_ITEM':
            let tempCat = state.categories[action.catIndex]
            tempCat.items = [
                ...tempCat.items.slice(0, action.itemIndex),
                ...tempCat.items.slice(action.itemIndex + 1)
            ]
            return {
                ...state,
                categories: [
                    ...state.categories.slice(0, action.catIndex),
                    tempCat,
                    ...state.categories.slice(action.catIndex + 1)
                ]
            }
        // FETCH CATEGORIES
        case FETCH_CATEGORIES_BEGIN:
            return {
                ...state,
                fetchCategories: {
                    loading: true,
                    error: false,
                    errorDetails: {}
                }
            }
        case FETCH_CATEGORIES_SUCCESS:
            return {
                ...state,
                fetchCategories: {
                    loading: false,
                    error: false,
                    errorDetails: {}
                },
                categories: action.payload.categories
            }
        case FETCH_CATEGORIES_ERROR:
            return {
                ...state,
                fetchCategories: {
                    loading: false,
                    error: true,
                    errorDetails: action.payload.error
                }
            }
        // TRI
        case FETCH_CATEGORIES_TRI_BEGIN:
            return {
                ...state,
                fetchCategoriesTri: {
                    loading: true,
                    error: false,
                    errorDetails: {}
                }
            }
        case FETCH_CATEGORIES_TRI_SUCCESS:
            return {
                ...state,
                fetchCategoriesTri: {
                    loading: false,
                    error: false,
                    errorDetails: {}
                },
                categoriesTri: action.payload.categories
            }
        case FETCH_CATEGORIES_TRI_ERROR:
            return {
                ...state,
                fetchCategoriesTri: {
                    loading: false,
                    error: true,
                    errorDetails: action.payload.error
                }
            }
        // FETCH ITEMCHECKER
        case FETCH_ITEMCHECKER_BEGIN:
            return {
                ...state,
                fetchItemChecker: {
                    loading: true,
                    error: false
                }
            }
        case FETCH_ITEMCHECKER_SUCCESS:
            return {
                ...state,
                fetchItemChecker: {
                    loading: false,
                    error: false
                },
                itemChecker: action.payload.itemChecker
            }
        case FETCH_ITEMCHECKER_ERROR:
            return {
                ...state,
                fetchItemChecker: {
                    loading: false,
                    error: action.payload.error
                }
            }
        // POST CATEGORIES
        case POST_CATEGORIES_BEGIN:
            return {
                ...state,
                postCategories: {
                    saved: false,
                    saving: true,
                    error: false
                }
            }
        case POST_CATEGORIES_ERROR:
            return {
                ...state,
                postCategories: {
                    saved: false,
                    saving: false,
                    error: action.payload.error
                }
            }
        case POST_CATEGORIES_SUCCESS:
            return {
                ...state,
                categories: action.payload.categories,
                postCategories: {
                    saved: true,
                    saving: false,
                    error: false
                }
            }
        case POST_CATEGORIES_RESET:
            return {
                ...state,
                postCategories: {
                    saved: false,
                    saving: false,
                    error: false
                }
            }

        // FETCH SOUSCATEGORIES
        case FETCH_LOTS_BEGIN:
            return {
                ...state,
                fetchLots: {
                    loading: true,
                    error: false,
                    errorDetails: {}
                }
            }
        case FETCH_LOTS_SUCCESS:
            return {
                ...state,
                fetchLots: {
                    loading: false,
                    error: false,
                    errorDetails: {}
                },
                lots: action.payload.lots
            }
        case FETCH_LOTS_ERROR:
            return {
                ...state,
                fetchLots: {
                    loading: false,
                    error: true,
                    errorDetails: action.payload.error
                }
            }
        // POST LOTS
        case POST_LOTS_BEGIN:
            return {
                ...state,
                postLots: {
                    saved: false,
                    saving: true,
                    error: false
                }
            }
        case POST_LOTS_ERROR:
            return {
                ...state,
                postLots: {
                    saved: false,
                    saving: false,
                    error: action.payload.error
                }
            }
        case POST_LOTS_SUCCESS:
            return {
                ...state,
                lots: action.payload.lots,
                postLots: {
                    saved: true,
                    saving: false,
                    error: false
                }
            }
        case POST_LOTS_RESET:
            return {
                ...state,
                postLots: {
                    saved: false,
                    saving: false,
                    error: false
                }
            }

        // FETCH ITEMS
        case FETCH_ITEMS_BEGIN:
            return {
                ...state,
                fetchItems: {
                    loading: true,
                    error: false,
                    errorDetails: {}
                }
            }
        case FETCH_ITEMS_SUCCESS:
            return {
                ...state,
                fetchItems: {
                    loading: false,
                    error: false,
                    errorDetails: {}
                },
                items: action.payload.items
            }
        case FETCH_ITEMS_ERROR:
            return {
                ...state,
                fetchItems: {
                    loading: false,
                    error: true,
                    errorDetails: action.payload.error
                }
            }
        // POST ITEMS
        case POST_ITEMS_BEGIN:
            return {
                ...state,
                postItems: {
                    saved: false,
                    saving: true,
                    error: false
                }
            }
        case POST_ITEMS_ERROR:
            return {
                ...state,
                postItems: {
                    saved: false,
                    saving: false,
                    error: action.payload.error
                }
            }
        case POST_ITEMS_SUCCESS:
            return {
                ...state,
                items: action.payload.items,
                postItems: {
                    saved: true,
                    saving: false,
                    error: false
                }
            }
        case POST_ITEMS_RESET:
            return {
                ...state,
                postItems: {
                    saved: false,
                    saving: false,
                    error: false
                }
            }

        // FETCH LOTUSAGES
        case FETCH_LOTUSAGES_BEGIN:
            return {
                ...state,
                fetchLotUsages: {
                    loading: true,
                    error: false,
                    errorDetails: {}
                }
            }
        case FETCH_LOTUSAGES_SUCCESS:
            return {
                ...state,
                fetchLotUsages: {
                    loading: false,
                    error: false,
                    errorDetails: {}
                },
                lotUsages: action.payload.lotUsages
            }
        case FETCH_LOTUSAGES_ERROR:
            return {
                ...state,
                fetchLotUsages: {
                    loading: false,
                    error: true,
                    errorDetails: action.payload.error
                }
            }
        // POST LOTUSAGES
        case POST_LOTUSAGES_BEGIN:
            return {
                ...state,
                postLotUsages: {
                    saved: false,
                    saving: true,
                    error: false
                }
            }
        case POST_LOTUSAGES_ERROR:
            return {
                ...state,
                postLotUsages: {
                    saved: false,
                    saving: false,
                    error: action.payload.error
                }
            }
        case POST_LOTUSAGES_SUCCESS:
            return {
                ...state,
                lotUsages: action.payload.lotUsages,
                postLotUsages: {
                    saved: true,
                    saving: false,
                    error: false
                }
            }
        case POST_LOTUSAGES_RESET:
            return {
                ...state,
                postLotUsages: {
                    saved: false,
                    saving: false,
                    error: false
                }
            }
        default:
            return state
    }
}